import { connect } from 'react-redux';
import { registerThunk, getTokenThunk, googleAuthRegisterThunk } from 'src/store/Auth/actions';
import { default as RegisterRoot } from './Register';

const mapStateToProps = ({ auth }) => ({
  loading: auth.loading,
  error: auth.error,
  errorReason: auth.reason,
});

const mapDispathToProps = {
  registerThunk,
  getTokenThunk,
  googleAuthRegisterThunk,
};

export const Register = connect(mapStateToProps, mapDispathToProps)(RegisterRoot);
